export function buildNutritionEditorActionItems({
  t,
  includeAssign = false,
  includeDuplicate = false,
  includeDelete = false,
  includeExportPdf = false,
  isExportingPdf = false,
  syncStatus = null,
} = {}) {
  const items = [];

  if (includeExportPdf) {
    items.push({
      key: "exportPdf",
      label: t?.("exportPdf-string", "Export PDF") ?? "Export PDF",
      icon: { type: "ionicons", name: "print-outline" },
      disabled: isExportingPdf === true,
      isDanger: false,
      syncStatus,
    });
  }

  if (includeAssign) {
    items.push({
      key: "assign",
      label:
        t?.("nutritionPlanAssignAction-string", "Duplicate for athlete") ??
        "Duplicate for athlete",
      icon: { type: "ionicons", name: "people-outline" },
      disabled: false,
      isDanger: false,
      syncStatus,
    });
  }

  if (includeDuplicate) {
    items.push({
      key: "duplicate",
      label: t?.("duplicate-string", "Duplicate") ?? "Duplicate",
      icon: { type: "ionicons", name: "duplicate-outline" },
      disabled: false,
      isDanger: false,
      syncStatus,
    });
  }

  if (includeDelete) {
    items.push({
      key: "delete",
      label: t?.("delete-string", "Delete") ?? "Delete",
      icon: { type: "ionicons", name: "trash-outline" },
      disabled: false,
      isDanger: true,
      syncStatus,
    });
  }

  return items;
}
